import React, { useState } from 'react';
import Card from './ui/Card';
import Badge from './ui/Badge';
import Button from './ui/Button';

const { Header: CardHeader, Content: CardContent, Title: CardTitle } = Card;

const ServiceProposalPage: React.FC = () => {
  const [showAIDetails, setShowAIDetails] = useState(false);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [showMobileDetails, setShowMobileDetails] = useState(false);
  const [showReservationDetails, setShowReservationDetails] = useState(false);
  const [showGoalDetails, setShowGoalDetails] = useState(false);
  const [showKakaoDetails, setShowKakaoDetails] = useState(false);
  const [showStudyTimeDetails, setShowStudyTimeDetails] = useState(false);
  const [showSeatMonitoringDetails, setShowSeatMonitoringDetails] = useState(false);
  const [showMemberManagementDetails, setShowMemberManagementDetails] = useState(false);
  const [showSeatLayoutDetails, setShowSeatLayoutDetails] = useState(false);
  const [showRevenueStatsDetails, setShowRevenueStatsDetails] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        {/* 헤더 섹션 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            NewAttend 관리형 독서실 솔루션
          </h1>
          <p className="text-xl text-gray-600 mb-6">
            AI가 관리하고, 카카오톡이 신뢰를 만드는 완전 자동화 독서실 시스템
          </p>
          <div className="flex justify-center space-x-4">
            <Badge className="bg-green-100 text-green-800 px-4 py-2">
              카카오톡 알림 차별화
            </Badge>
            <Badge className="bg-blue-100 text-blue-800 px-4 py-2">
              완전 무인 운영
            </Badge>
            <Badge className="bg-purple-100 text-purple-800 px-4 py-2">
              AI 자동화 관리
            </Badge>
          </div>
        </div>

        {/* 가격 정책 섹션 */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Phase 1 */}
          <Card className="border-2 border-orange-200 shadow-lg">
            <CardHeader className="bg-orange-50">
              <CardTitle className="text-2xl text-orange-800 flex items-center justify-between">
                Phase 1: 현재 서비스
                <Badge className="bg-orange-500 text-white">현재 제공</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <h3 className="font-bold text-lg mb-4 text-gray-800">지금 바로 사용 가능</h3>
              
              <div className="mb-6">
                <h4 className="font-semibold text-gray-700 mb-2">독서실 사장님께</h4>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowSeatMonitoringDetails(!showSeatMonitoringDetails)}
                    >
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      <strong className="flex-1">좌석 현황 실시간 모니터링</strong>
                      <span className="text-gray-400 ml-2">
                        {showSeatMonitoringDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showSeatMonitoringDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">실시간 현황</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 좌석 사용/대기 상태 표시</li>
                              <li>• 사용자별 이용 시간</li>
                              <li>• 좌석별 온도/습도 모니터링 (별도 기기 필요)</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">시각화 대시보드</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 좌석 배치도 컬러 코딩</li>
                              <li>• 이용률 히트맵</li>
                              <li>• 시간대별 현황 그래프</li>
                              <li>• 층별/구역별 현황</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">알림 시스템</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 만석 임박 알림</li>
                              <li>• 장시간 자리 비움 감지</li>
                              <li>• 좌석 이상 상황 알림</li>
                              <li>• 청소 시간 안내</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">관리 기능</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 원격 좌석 제어</li>
                              <li>• 좌석 강제 해제</li>
                              <li>• 구역별 접근 제한</li>
                              <li>• 비상 상황 대응</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowMemberManagementDetails(!showMemberManagementDetails)}
                    >
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      <strong className="flex-1">회원 출입 기록 관리</strong>
                      <span className="text-gray-400 ml-2">
                        {showMemberManagementDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showMemberManagementDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">출입 기록</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 입실/퇴실 시간 자동 기록</li>
                              <li>• 얼굴 인식 출입 로그</li>
                              <li>• QR 체크인 기록</li>
                              <li>• 비정상 출입 감지</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">회원 정보 관리</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 회원 등록/수정/삭제</li>
                              <li>• 이용권 현황 관리</li>
                              <li>• 연체 회원 자동 표시</li>
                              <li>• 회원별 이용 패턴</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">검색 및 필터</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 회원명/번호로 검색</li>
                              <li>• 날짜별 출입 조회</li>
                              <li>• 이용권 상태별 필터</li>
                              <li>• 출입 빈도별 정렬</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">보고서 생성</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일별/월별 출입 현황</li>
                              <li>• 회원별 이용 통계</li>
                              <li>• 출입 기록 엑셀 다운로드</li>
                              <li>• 정기 리포트 자동 생성</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowSeatLayoutDetails(!showSeatLayoutDetails)}
                    >
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      <strong className="flex-1">좌석 배치 관리</strong>
                      <span className="text-gray-400 ml-2">
                        {showSeatLayoutDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showSeatLayoutDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">좌석 설계</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 드래그 앤 드롭 좌석 배치</li>
                              <li>• 구역별 좌석 그룹핑</li>
                              <li>• 좌석 번호 자동 할당</li>
                              <li>• 층별 좌석 관리</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">좌석 유형 설정</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일반석/VIP석 구분</li>
                              <li>• 좌석별 요금 설정</li>
                              <li>• 특수 좌석 (창가, 콘센트)</li>
                              <li>• 장애인 전용석 관리</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">시설물 관리</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 조명/콘센트 위치</li>
                              <li>• 에어컨/난방 구역</li>
                              <li>• CCTV 설치 위치</li>
                              <li>• 소음 차단 구역</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowRevenueStatsDetails(!showRevenueStatsDetails)}
                    >
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      <strong className="flex-1">기본 매출 통계</strong>
                      <span className="text-gray-400 ml-2">
                        {showRevenueStatsDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showRevenueStatsDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">매출 현황</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일별/주별/월별 매출</li>
                              <li>• 이용권별 판매 현황</li>
                              <li>• 결제 수단별 통계</li>
                              <li>• 실시간 매출 모니터링</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">회원 분석</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 신규/기존 회원 비율</li>
                              <li>• 회원별 매출 기여도</li>
                              <li>• 이용 패턴 분석</li>
                              <li>• 회원 유지율 추적</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">수익성 분석</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 좌석별 수익률</li>
                              <li>• 시간대별 매출 분석</li>
                              <li>• 요일별 수익 패턴</li>
                              <li>• 계절별 매출 변화</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">리포트 기능</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 매출 리포트 자동 생성</li>
                              <li>• 그래프/차트 시각화</li>
                              <li>• 엑셀/PDF 다운로드</li>
                              <li>• 정기 리포트 이메일 발송</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowKakaoDetails(!showKakaoDetails)}
                    >
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      <strong className="flex-1">학부모 카카오톡 실시간 알림 발송</strong>
                      <span className="text-gray-400 ml-2">
                        {showKakaoDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showKakaoDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">출입 알림</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 입실 시 즉시 알림</li>
                              <li>• 퇴실 시 즉시 알림</li>
                              <li>• 장시간 자리 비움 알림</li>
                              <li>• 비정상 시간 출입 알림</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">학습 현황</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일별 순공부시간 요약</li>
                              <li>• 주별 학습 패턴 분석</li>
                              <li>• 월별 성취도 리포트</li>
                              <li>• 목표 달성률 알림</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">결제 관련</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 이용권 만료 예정 알림</li>
                              <li>• 결제 완료 확인</li>
                              <li>• 연체 안내</li>
                              <li>• 요금제 변경 안내</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">맞춤 설정</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 알림 시간대 설정</li>
                              <li>• 알림 빈도 조절</li>
                              <li>• 특별 이벤트 알림</li>
                              <li>• 긴급 상황 알림</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-gray-700 mb-2">학생/학부모께</h4>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    얼굴 인식 출입
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    QR 체크인
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    기본 이용 시간 확인
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                    <strong>카카오톡으로 출입 알림 받기</strong>
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowStudyTimeDetails(!showStudyTimeDetails)}
                    >
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      <strong className="flex-1">정확한 순공부시간 측정</strong>
                      <span className="text-gray-400 ml-2">
                        {showStudyTimeDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showStudyTimeDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">자동 시간 측정</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 입실/퇴실 자동 기록</li>
                              <li>• 자리 비움 시간 자동 제외</li>
                              <li>• 휴식 시간 구분</li>
                              <li>• 실제 학습 시간만 계산</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">통계 분석</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일별/주별/월별 통계</li>
                              <li>• 시간대별 집중도 분석</li>
                              <li>• 요일별 학습 패턴</li>
                              <li>• 목표 대비 달성률</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">개인별 리포트</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 학습 효율성 분석</li>
                              <li>• 집중 시간대 파악</li>
                              <li>• 개선 포인트 제안</li>
                              <li>• 성과 변화 추적</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">학부모 공유</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 실시간 학습 현황</li>
                              <li>• 주간 성과 리포트</li>
                              <li>• 목표 달성 알림</li>
                              <li>• 학습 패턴 공유</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>

          {/* Phase 2 */}
          <Card className="border-2 border-blue-200 shadow-lg">
            <CardHeader className="bg-blue-50">
              <CardTitle className="text-2xl text-blue-800 flex items-center justify-between">
                Phase 2: 완전 서비스
                <Badge className="bg-blue-500 text-white">3개월 후</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <h3 className="font-bold text-lg mb-4 text-gray-800">Phase 1 + 추가 기능</h3>
              
              <div className="mb-6">
                <h4 className="font-semibold text-gray-700 mb-2">새로 추가되는 핵심 기능</h4>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowAIDetails(!showAIDetails)}
                    >
                      <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                      <strong className="flex-1">AI 관리 자동화 지침</strong>
                      <span className="text-gray-400 ml-2">
                        {showAIDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showAIDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">회원 관리 자동화</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• "김OO님 연체 3일째, 연락 필요"</li>
                              <li>• "이OO님 2주간 미이용, 연락 권장"</li>
                              <li>• "박OO님 이용권 3일 후 만료"</li>
                              <li>• "최OO님 이번 주 지각 3회, 상담 필요"</li>
                              <li>• "정OO님 자리 비움 잦음, 집중도 저하"</li>
                              <li>• "송OO님 새벽 시간 이용 증가 패턴"</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">시설 운영 자동화</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• "A구역 이용률 30%, 재배치 권장"</li>
                              <li>• "화장실 청소 시간입니다"</li>
                              <li>• "후문 미잠금 감지, 확인 필요"</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">매출 최적화</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• "이번 주 매출 20% 감소, 분석 필요"</li>
                              <li>• "다음 주 만석 예상, 대기자 준비"</li>
                              <li>• "VIP석 요금 인상 권장"</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">예측 분석</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• "시험 기간 전, 좌석 30% 증설 권장"</li>
                              <li>• "오후 3-6시 혼잡 예상"</li>
                              <li>• "학기 시작 2주 전, 홍보 최적 시기"</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowPaymentDetails(!showPaymentDetails)}
                    >
                      <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                      <strong className="flex-1">자동 결제/정산 시스템</strong>
                      <span className="text-gray-400 ml-2">
                        {showPaymentDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showPaymentDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">자동 결제</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 이용권 자동 갱신</li>
                              <li>• 카드/계좌 자동 결제</li>
                              <li>• 결제 실패 시 재시도</li>
                              <li>• 결제 완료 즉시 알림</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">정산 관리</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일별 매출 자동 집계</li>
                              <li>• 월별 정산 리포트</li>
                              <li>• 세금계산서 자동 발행</li>
                              <li>• 수수료 자동 계산</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">연체 관리</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 연체 자동 감지</li>
                              <li>• 단계별 알림 발송</li>
                              <li>• 이용 제한 자동 설정</li>
                              <li>• 연체료 자동 계산</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">통계 분석</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 매출 추이 분석</li>
                              <li>• 회원별 결제 패턴</li>
                              <li>• 수익성 분석</li>
                              <li>• 예측 매출 산출</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowMobileDetails(!showMobileDetails)}
                    >
                      <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                      <strong className="flex-1">모바일 앱 서비스</strong>
                      <span className="text-gray-400 ml-2">
                        {showMobileDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showMobileDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">학부모용 앱</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 실시간 출입 현황</li>
                              <li>• 순공부시간 확인</li>
                              <li>• 학습 패턴 분석</li>
                              <li>• 목표 달성률 조회</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">학생용 앱</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 좌석 예약/연장</li>
                              <li>• 개인 학습 통계</li>
                              <li>• 목표 설정/관리</li>
                              <li>• 스터디 그룹 참여</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">관리자용 앱</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 실시간 운영 현황</li>
                              <li>• 매출 통계 확인</li>
                              <li>• 긴급 알림 수신</li>
                              <li>• 원격 시설 제어</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">공통 기능</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 푸시 알림</li>
                              <li>• 오프라인 모드</li>
                              <li>• 다크 모드 지원</li>
                              <li>• 생체 인증</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowReservationDetails(!showReservationDetails)}
                    >
                      <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                      <strong className="flex-1">좌석 예약 시스템</strong>
                      <span className="text-gray-400 ml-2">
                        {showReservationDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showReservationDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">예약 기능</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 사전 좌석 예약</li>
                              <li>• 시간대별 예약</li>
                              <li>• 연속 예약 가능</li>
                              <li>• 예약 취소/변경</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">스마트 추천</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 선호 좌석 추천</li>
                              <li>• 최적 시간대 제안</li>
                              <li>• 혼잡도 기반 추천</li>
                              <li>• 학습 패턴 기반 제안</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">대기열 관리</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 자동 대기열 등록</li>
                              <li>• 실시간 대기 현황</li>
                              <li>• 좌석 배정 알림</li>
                              <li>• 우선순위 관리</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">관리 기능</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 노쇼 방지 시스템</li>
                              <li>• 예약 통계 분석</li>
                              <li>• 좌석 이용률 최적화</li>
                              <li>• 수익 극대화 알고리즘</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                  <li className="flex flex-col">
                    <div 
                      className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors"
                      onClick={() => setShowGoalDetails(!showGoalDetails)}
                    >
                      <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                      <strong className="flex-1">학생 목표설정 관리</strong>
                      <span className="text-gray-400 ml-2">
                        {showGoalDetails ? '▼' : '▶'}
                      </span>
                    </div>
                    
                    {showGoalDetails && (
                      <div className="mt-3 ml-5 bg-gray-50 p-4 rounded-lg">
                        <div className="grid md:grid-cols-2 gap-4 text-sm">
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">목표 설정</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 일별/주별/월별 목표</li>
                              <li>• 과목별 목표 관리</li>
                              <li>• 시험 대비 계획</li>
                              <li>• 맞춤형 목표 추천</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">진도 추적</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 실시간 달성률 확인</li>
                              <li>• 학습 진도 시각화</li>
                              <li>• 목표 대비 현황</li>
                              <li>• 성취도 분석</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">동기부여</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 성취 배지 시스템</li>
                              <li>• 랭킹 시스템</li>
                              <li>• 목표 달성 축하</li>
                              <li>• 학습 습관 형성</li>
                            </ul>
                          </div>
                          <div>
                            <h5 className="font-semibold text-gray-700 mb-2">학부모 연동</h5>
                            <ul className="space-y-1 text-gray-600">
                              <li>• 목표 공유 기능</li>
                              <li>• 진도 상황 알림</li>
                              <li>• 성취 축하 메시지</li>
                              <li>• 상담 자료 제공</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                </ul>
              </div>

            </CardContent>
          </Card>
        </div>

        {/* 경쟁 우위 섹션 */}
        <Card className="mb-12 bg-gradient-to-r from-green-50 to-blue-50">
          <CardHeader>
            <CardTitle className="text-2xl text-center text-gray-800">
              NewAttend 서비스 플랜
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex justify-center">
              <div className="text-center">
                <div className="bg-blue-100 p-6 rounded-lg mb-4">
                  <h3 className="font-bold text-blue-800 text-xl">NewAttend 관리형 독서실 솔루션</h3>
                  <p className="text-blue-600 text-3xl font-bold mt-2">월 99만원</p>
                  <p className="text-blue-500 text-sm mt-2">AI 자동화 + 카카오톡 알림 + 완전 무인 관리</p>
                  <p className="text-blue-400 text-xs mt-1">현재 서비스 + 향후 확장 포함</p>
                  <p className="text-orange-600 text-sm font-semibold mt-2">설치 및 셋팅비: 50만원 (최초 1회)</p>
                </div>
              </div>
            </div>
            
            <div className="mt-6 text-center">
              <div className="inline-flex items-center space-x-4 bg-white p-4 rounded-lg shadow">
                <span className="text-green-600 font-bold text-lg">절약 효과</span>
                <span className="text-gray-600">인건비 월 200만원 → 시스템 관리비</span>
                <span className="text-green-600 font-bold">60% 이상 절약!</span>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* 장기 로드맵 섹션 */}
        <Card className="mb-12">
          <CardHeader>
            <CardTitle className="text-2xl text-center text-gray-800">
              장기 로드맵 (추가 비용 없음)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-bold text-lg mb-3 text-blue-600">2차 확장 (6개월 내)</h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                    개인 맞춤 학습 분석
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                    고급 통계 및 리포트
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                    스마트 알림 고도화
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-orange-400 rounded-full mr-3"></span>
                    <strong>학원 연계 서비스</strong>
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-orange-400 rounded-full mr-3"></span>
                    <strong>학교 일정표 공유 시스템</strong>
                  </li>
                </ul>
              </div>
              
              <div>
                <h3 className="font-bold text-lg mb-3 text-purple-600">3차 확장 (1년 내)</h3>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-400 rounded-full mr-3"></span>
                    스마트 환경 자동 제어
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-400 rounded-full mr-3"></span>
                    스터디 커뮤니티
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-purple-400 rounded-full mr-3"></span>
                    운영 최적화 컨설팅
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="mt-6 bg-orange-50 p-4 rounded-lg">
              <h4 className="font-semibold text-orange-700 mb-2">학원 연계 서비스 상세</h4>
              <div className="grid md:grid-cols-2 gap-4 text-sm text-orange-600">
                <ul className="space-y-1">
                  <li>• 학원 출석 정보 연동</li>
                  <li>• 독서실-학원 통합 관리</li>
                  <li>• 학습 패턴 종합 분석</li>
                </ul>
                <ul className="space-y-1">
                  <li>• 학교 시험 일정 자동 등록</li>
                  <li>• 중요 일정 카카오톡 알림</li>
                  <li>• 학부모 일정 공유</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* CTA 섹션 */}
        <div className="text-center bg-white p-8 rounded-lg shadow-lg">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            지금 시작하세요!
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            NewAttend로 완전 자동화 독서실을 경험해보세요
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
            <div className="bg-green-50 p-4 rounded-lg">
              <span className="text-green-600 font-bold">전문 상담</span>
              <p className="text-sm text-green-500">맞춤형 솔루션 제안</p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg">
              <span className="text-blue-600 font-bold">시스템 관리</span>
              <p className="text-sm text-blue-500">안정적인 운영 보장</p>
            </div>
          </div>
          
          <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <Button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 text-lg">
              상담 신청하기
            </Button>
            <Button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 text-lg">
              상세 자료 요청
            </Button>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ServiceProposalPage;